import type { LocalCardStates, LocalStorageFunctions } from './types';

const CARD_STATES: string = 'tigim-card-states';

const getObj = (fn: LocalStorageFunctions) => () => fn.readObject<Record<string, boolean>>(CARD_STATES);

const get = (fn: LocalStorageFunctions) => (id: string, defaultValue: boolean = true): boolean => {
  const obj = getObj(fn)();
  if (obj?.[id] !== undefined) return obj[id];
  return defaultValue;
};

const set = (fn: LocalStorageFunctions) => (id: string, isOpen: boolean) => {
  const obj = getObj(fn)();
  if (!obj) {
    fn.writeObject(CARD_STATES, { [id]: isOpen });
    return;
  }
  obj[id] = isOpen;
  fn.writeObject(CARD_STATES, obj);
};

const cardStates = (fn: LocalStorageFunctions): LocalCardStates => ({
  getLocalStorageCardState: get(fn),
  setLocalStorageCardState: set(fn)
});

export default cardStates;
